interface Tenant {
  id: string;
  name: string;
}

interface TenantDisplayInfo {
  shortName: string;
  longName: string;
  backgroundColor: string;
}

const TENANT_DISPLAY_MAP: Record<string, TenantDisplayInfo> = {
  "fa7f66de-5375-46f1-bc8a-90921c656138": {
    shortName: "AC",
    longName: "Alles Clara",
    backgroundColor: "#D2BBFF",
  },
  "59cf131a-b4c0-46f8-a754-197344d4145b": {
    shortName: "CC",
    longName: "Clara Cares",
    backgroundColor: "#B3C5FF",
  },
  "fa7f66de-5375-46f1-bc8a-90921c656133": {
    shortName: "VW",
    longName: "Verein Wohnen",
    backgroundColor: "#96E6C1",
  },
  "bildung-hat-wert": {
    shortName: "BW",
    longName: "Bildung hat Wert",
    backgroundColor: "#FFDE34",
  },
};

const DEFAULT_TENANT: Tenant = {
  id: "fa7f66de-5375-46f1-bc8a-90921c656138",
  name: "alles-clara",
};

type Subscriber = () => void;

class TenantService {
  private static instance: TenantService;
  private currentTenant: Tenant = DEFAULT_TENANT;
  private subscribers: Set<Subscriber> = new Set();

  private constructor() {
    this.currentTenant = DEFAULT_TENANT;
  }

  public static getInstance(): TenantService {
    if (!TenantService.instance) {
      TenantService.instance = new TenantService();
    }
    return TenantService.instance;
  }

  public setCurrentTenant(tenant: Tenant): void {
    this.currentTenant = tenant;
    this.notifySubscribers();
  }

  public getCurrentTenant(): Tenant {
    return this.currentTenant;
  }

  public getTenantDisplayInfo(tenantId: string, tenantName?: string): TenantDisplayInfo {
    return (
      TENANT_DISPLAY_MAP[tenantId] || {
        shortName: (tenantName || this.currentTenant.name).substring(0, 2).toUpperCase(),
        longName: tenantName || this.currentTenant.name,
        backgroundColor: "#E6E6E6",
      }
    );
  }

  public getCurrentTenantDisplayInfo(): TenantDisplayInfo {
    return this.getTenantDisplayInfo(this.currentTenant.id, this.currentTenant.name);
  }

  public subscribe(callback: Subscriber): () => void {
    this.subscribers.add(callback);
    return () => {
      this.subscribers.delete(callback);
    };
  }

  private notifySubscribers(): void {
    this.subscribers.forEach((callback) => callback());
  }
}

export const tenantService = TenantService.getInstance();
